import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'shared/components/modal';

export default class ShutDownConfirmationModal extends React.Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    onDismiss: PropTypes.func.isRequired,
    onShutdown: PropTypes.func.isRequired,
    universityName: PropTypes.string.isRequired,
  };

  render() {
    const {show, onDismiss, onShutdown, universityName} = this.props;

    return (
      <Modal show={show} onClose={onDismiss}>
        <Modal.TextHeader onClose={onDismiss}>Are you Sure?</Modal.TextHeader>
        <Modal.Body>
          Are you sure you want to shut down {universityName}? This action will:
          <ul>
            <li>Set a churned_at date for this partner</li>
            <li>Deactivate all non-internal user accounts for this partner</li>
            <li>Prevent new followers from earning</li>
            <li>Freeze earnings for current followers</li>
          </ul>
        </Modal.Body>
        <Modal.Footer
          primaryButton={{
            text: 'SHUT IT DOWN!',
            color: 'red',
            onClick: onShutdown,
          }}
          secondaryButton={{
            text: 'Yikes, nevermind!',
            onClick: onDismiss,
            rightAligned: true,
          }}
        />
      </Modal>
    );
  }
}
